import { Grid } from '@mui/material'
import { capitalizza, formattaDataEOra, ICONE, BaseGridLayout } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { DATICONDUCENTE_VERBALE_RIEPILOGO } from 'configuration/datiConducente'
import ConfigManager from 'components/config/ConfigManager'
import ScatolettaRiepilogo from 'components/ui/ScatolettaRiepilogo'
import ScatolettaDownloadAllegato from 'components/ui/ScatolettaDownloadAllegato'
import Sezione from 'components/ui/Sezione'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import BadgeStatoDatiConducente from 'components/ui/datiConducente/BadgeStatoDatiConducente'
import { calcolaStatoDatiConducenteVerbale, STATO_DATI_CONDUCENTE_VERBALE } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_VERBALE_RIEPILOGO

export default function Riepilogo(props) {
  const { chiaveVerbale, verbale } = props
  const {
    numero_verbale,
    infrazione_data,
    contestazione_data,
    articoli,
    punti,
    intestatario,
    veicolo,
    procedura,
    files,
    stato_messaggio,
  } = verbale

  const stato = calcolaStatoDatiConducenteVerbale(verbale)
  const nonDaCompilare = stato !== STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE
  const nonDisponibile = stato === STATO_DATI_CONDUCENTE_VERBALE.MODULO_NON_DISPONIBILE

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_VERBALE_RIEPILOGO]}
      render={({ txt }) =>
        <BaseGridLayout vertical spacing={3} noWrap>
          <>
            <Titoletto>
              {txt(CFG.TITOLO)} {numero_verbale}
              <BadgeStatoDatiConducente verbale={verbale} sx={{ ml: 4 }} />
            </Titoletto>
            <Testo noMargine>{txt(CFG.SOTTOTITOLO)}</Testo>
          </>

          <Sezione titolo={txt(CFG.SEZIONI_DATI_VERBALE)}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.DESCRIZIONE} titolo={txt(CFG.SEZIONI_NUMERO_VERBALE)}>
                  <Testo grassetto>{capitalizza(procedura)} {numero_verbale}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.CALENDARIO_EVENTO} titolo={txt(CFG.SEZIONI_DATA_INFRAZIONE)}>
                  <Testo grassetto>{formattaDataEOra(infrazione_data)}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.NOTIFICA_IMPORTANTE} titolo={txt(CFG.SEZIONI_DATA_CONTESTAZIONE)}>
                  <Testo grassetto>{formattaDataEOra(contestazione_data)}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.MARTELLETTO} titolo={txt(CFG.SEZIONI_NORMATIVA)}>
                  <Testo grassetto>{txt(CFG.SEZIONI_NORMATIVA_VIOLAZIONE)} {articoli}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.PERSONA} titolo={txt(CFG.SEZIONI_INTESTATARIO)}>
                  <Testo grassetto>{intestatario}</Testo>
                </ScatolettaRiepilogo>
              </Grid>

              <Grid item xs={12} md={4}>
                <ScatolettaRiepilogo Icona={ICONE.VEICOLO} titolo={txt(CFG.SEZIONI_VEICOLO)}>
                  <Testo grassetto>{veicolo}</Testo>
                </ScatolettaRiepilogo>
              </Grid>
            </Grid>
          </Sezione>

          <Sezione
            titolo={txt(CFG.TITOLO_DECURTAZIONE)}
            sottotitolo={punti > 0 && txt(CFG.SOTTOTITOLO_DECURTAZIONE)}
          >
            <ScatolettaRiepilogo Icona={ICONE.VEICOLO_ATTENZIONE} titolo={txt(CFG.SEZIONI_DECURTAZIONE, { punti })}>
              {nonDisponibile ? (
                <MessaggioEvidenziato info titolo={txt(CFG.SEZIONI_DECURTAZIONE_AVVISO_MODULO_NON_DISPONIBILE_TITOLO)}>
                  {txt(CFG.SEZIONI_DECURTAZIONE_AVVISO_MODULO_NON_DISPONIBILE_DESCR)}
                </MessaggioEvidenziato>
              ) : (
                <MessaggioEvidenziato warning titolo={txt(CFG.SEZIONI_DECURTAZIONE_AVVISI)}>
                  {stato_messaggio || txt(CFG.SEZIONI_DECURTAZIONE_AVVISI_DATI_NON_INSERITI)}
                </MessaggioEvidenziato>
              )}
            </ScatolettaRiepilogo>
          </Sezione>

          <Sezione
            titolo={txt(CFG.SEZIONI_DOCUMENTI_SCARICABILI)}
            sottotitolo={txt(CFG.SEZIONI_DOCUMENTI_SCARICABILI_SOTTOTITOLO)}
          >
            <Grid container spacing={2}>
              {files.map(file =>
                <Grid item xs={12} md={4} key={file.id}>
                  <ScatolettaDownloadAllegato
                    allegato={file}
                    chiavePerUuid={chiaveVerbale}
                  />
                </Grid>
              )}
            </Grid>
          </Sezione>

          <Testo hidden={nonDaCompilare}>{txt(CFG.ISTRUZIONI_PER_PROCEDERE)}</Testo>

          <MessaggioEvidenziato error titolo={txt(CFG.PROCEDURA_INCOMPLETA_TITOLO)} hidden={nonDaCompilare}>
            {txt(CFG.PROCEDURA_INCOMPLETA_DESCR)}
          </MessaggioEvidenziato>

          <MessaggioEvidenziato info titolo={txt(CFG.DOCUMENTAZIONE_NECESSARIA_TITOLO)} hidden={nonDaCompilare}>
            {txt(CFG.DOCUMENTAZIONE_NECESSARIA_DESCR)}
          </MessaggioEvidenziato>
        </BaseGridLayout>
      }
    />
  )
}
